<script setup>
import {ElIcon, ElMessage, ElImageViewer} from 'element-plus'
import {Delete, Plus, ZoomIn, Check} from '@element-plus/icons-vue'

import {reactive, ref, defineProps, defineEmits} from 'vue'
import axios from 'axios'
import apiClient from "@/components/plugins/axios";

const props = defineProps({
  modelValue: {
    type: Array,
    default: () => []
  },
  accept: {
    type: String,
    default: ''
  }
})
const emits = defineEmits(['update:modelValue'])
const pre = reactive({
  show: false,
  srcList: [],
  index: 0
})
const fileInput = ref()
const form = ref()
const canvasRefs = ref([])
const setCanvasRef = (el, index) => {
  canvasRefs.value[index] = el
}

const chooseFile = () => {
  fileInput.value.click()
}
const handleFileChange = (e) => {
  const file = e.target.files[0]
  if (props.accept !== '' && props.accept !== file.type.split('/')[0]) {
    ElMessage({
      message: '文件类型为' + props.accept,
      type: 'error',
      duration: 1000
    })
    return
  }
  if (file.size > 1024 * 1024 * 500) {
    ElMessage({
      message: '文件大小在500MB以内',
      type: 'error',
      duration: 1000
    })
    return
  }
  uploadFile(file)
  form.value.reset()
}
const uploadFile = async (file) => {
  // console.log(file)
  const blobUrl = URL.createObjectURL(new Blob([file], {type: file.type}))
  const {data} = await apiClient.get('/api/v1/common/oss/sts-signature_v2?upload_dir=' + 'client/upload/' + file.type.split('/')[0] + '&fileName=' + file.name)
  let formData = {
    key: data.data.key,
    policy: data.data.policy,
    OSSAccessKeyId: data.data.OSSAccessKeyId,
    Signature: data.data.signature,
    'x-oss-security-token': data.data.sts_token,
    success_action_status: data.data.success_action_status,
    file: file
  }
  const source = axios.CancelToken.source()
  const date = Date.now()
  const model = props.modelValue
  model.push({
    uid: date,
    url: blobUrl,
    percentage: 0,
    type: file.type.split('/')[0],
    cancelToken: source,
    status: 'ready'
  })
  emits('update:modelValue', model)
  const form = props.modelValue.find((item) => item.uid === date)
  const index = props.modelValue.findIndex((item) => item.uid === date)
  try {
    await axios.post(data.data.host, formData, {
      headers: {'Content-Type': 'multipart/form-data'},
      cancelToken: source.token,
      onUploadProgress: (res) => {
        form.percentage = Math.ceil(100 * res.progress)
        drawProgress(Math.ceil(100 * res.progress), index)
      }
    })
    form.url = data.data.host + '/' + data.data.key
    form.status = 'success'
    ElMessage({
      message: '上传成功',
      type: 'success',
      duration: 1000
    })
  } catch (e) {
    if (axios.isCancel(e)) {
      ElMessage({
        message: '已取消',
        type: 'success',
        duration: 1000
      })
    } else {
      form.status = 'fail'
      const newArr = props.modelValue.filter((item) => item.uid !== date)
      emits('update:modelValue', newArr)
      ElMessage({
        message: '上传失败',
        type: 'error',
        duration: 1000
      })
    }
  }
}
const removeFile = (data) => {
  if (data.status !== 'success') {
    data.cancelToken.cancel('已取消')
    data.status = 'cancel'
  }
  const newArr = props.modelValue.filter((item) => item.uid !== data.uid)
  emits('update:modelValue', newArr)
}
const drawProgress = (percent, index) => {
  if (canvasRefs.value[index].getContext('2d')) {
    const ctx = canvasRefs.value[index].getContext('2d')
    const center = 50
    const radius = 30
    const startAngle = -Math.PI / 2
    const endAngle = startAngle + (percent / 100) * 2 * Math.PI
    // console.log(percent)
    // console.log((percent / 100) * 2 * Math.PI)
    ctx.clearRect(0, 0, 100, 100)

    // 背景圆
    ctx.beginPath()
    ctx.arc(center, center, radius, 0, 2 * Math.PI)
    ctx.lineWidth = 4
    ctx.strokeStyle = '#969696'
    ctx.stroke()

    // 进度圆
    ctx.beginPath()
    ctx.arc(center, center, radius, startAngle, endAngle)
    ctx.lineWidth = 4
    ctx.strokeStyle = '#fff'
    ctx.lineCap = 'round'
    ctx.stroke()
  }
}
const handlePictureCardPreview = (index) => {
  pre.show = true
  pre.srcList = props.modelValue.map((item) => item.url)
  pre.index = index
}
</script>

<template>
  <div>
    <ul class="el-upload-list el-upload-list--picture-card">
      <li
          class="el-upload-list__item"
          :class="i.status === 'success' && 'is-success'"
          tabindex="0"
          v-for="(i, index) in modelValue"
          :key="index"
      >
        <div style="position: relative; width: 98px; height: 98px">
          <img
              v-if="i.type === 'image'"
              class="el-upload-list__item-thumbnail"
              :src="i.url"
              alt=""
          />
          <video
              v-if="i.type === 'video'"
              class="el-upload-list__item-thumbnail"
              :src="i.url"
          ></video>
          <label class="el-upload-list__item-status-label">
            <el-icon color="#fff">
              <Check/>
            </el-icon>
          </label>
          <span class="el-upload-list__item-actions">
            <span
                class="el-upload-list__item-preview"
                v-if="i.type === 'image'"
                @click="handlePictureCardPreview(index)"
            >
              <el-icon><zoom-in/></el-icon>
            </span>
            <span class="el-upload-list__item-delete" @click="removeFile(i)">
              <el-icon><Delete/></el-icon>
            </span>
          </span>
          <div class="back" v-show="i.status !== 'success'">
            <canvas
                :ref="(el) => setCanvasRef(el, index)"
                class="can"
                width="100"
                height="100"
            ></canvas>
            <div class="num">{{ i.percentage }}%</div>
          </div>
        </div>
      </li>
      <div class="el-upload el-upload--picture-card" tabindex="0" @click="chooseFile">
        <el-icon>
          <Plus/>
        </el-icon>
        <form ref="form">
          <input
              class="el-upload__input"
              name="file"
              accept=""
              type="file"
              ref="fileInput"
              @change="handleFileChange"
          />
        </form>
      </div>
    </ul>
    <div v-if="accept === 'video'" class="el-upload__tip">视频大小在200MB以内</div>
  </div>
  <el-image-viewer
      v-if="pre.show"
      :url-list="pre.srcList"
      :initial-index="pre.index"
      @close="pre.show = false"
      :hide-on-click-modal="true"
  />
</template>

<style scoped>
.el-upload--picture-card {
  width: 100px;
  height: 100px;
}

.el-upload-list__item {
  width: 100px;
  height: 100px;
}

.back {
  background: rgba(0, 0, 0, 0.8);
  width: 100px;
  height: 100px;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 99;
}

.el-upload-list__item:hover .back {
  display: none;
}

.can {
  width: 100%;
  height: 100%;
}

.num {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
}
</style>
